<template>
  <a
    :class="b()"
    :href="url"
    :target="target"
    :title="title"
    :rel="rel"
    :aria-label="title || label || url"
    :referrerpolicy="referrerpolicy"
    v-bind="$attrs"
  >
    <slot v-if="$slots.default"></slot>
    <template v-else>{{ label }}</template>
  </a>
</template>

<script lang="ts">
  import { PropType, defineComponent } from 'vue';
  import { Link } from '@/types/link';
  import { NavigationItem } from '@/types/navigation';

  type ReferrerTypes =
    | ''
    | 'no-referrer'
    | 'no-referrer-when-downgrade'
    | 'origin'
    | 'origin-when-cross-origin'
    | 'same-origin'
    | 'strict-origin'
    | 'strict-origin-when-cross-origin'
    | 'unsafe-url';

  // type Setup = {}
  // type Data = {}

  /**
   * Renders a html link.
   */
  export default defineComponent({
    name: 'e-link',
    inheritAttrs: false,

    // components: {},

    props: {
      /**
       * The link object.
       */
      link: {
        type: Object as PropType<Partial<Link>>,
        required: true,
      },
    },
    // emits: [],

    // setup(): Setup {
    //   return {};
    // },
    // data(): Data {
    //   return {};
    // },

    computed: {
      linkObject(): Partial<Link> | Partial<NavigationItem> {
        return this?.link || {};
      },

      title(): string | undefined {
        return this.linkObject?.title || undefined;
      },

      target(): string | undefined {
        return this.linkObject?.target || undefined;
      },

      rel(): string | undefined {
        return this.linkObject?.rel || undefined;
      },

      referrerpolicy(): ReferrerTypes | undefined {
        return this.linkObject?.referrerpolicy || undefined;
      },

      label(): string {
        return this.linkObject?.label || '';
      },

      url(): string | undefined {
        if ('url' in this.linkObject) {
          return this.linkObject.url;
        }

        if ('uri' in this.linkObject) {
          return this.linkObject.uri;
        }

        return '';
      },
    },
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  });
</script>

<style lang="scss">
  // @use '@/setup/scss/mixins';
  // @use '@/setup/scss/variables';

  .e-link {
    $this: &;
  }
</style>
